import { GET_STUDENT_UPCOMING_COURSES } from "./actionTypes";
import axios from "axios";
import apiConfig from '../../../apiConfig/api';

const headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
};

export const getupcomingSchedules = (data)=>{
    return{
        type: GET_STUDENT_UPCOMING_COURSES,
        payload: data
    }
}

export const retrieveUpcomingCourses = (data)=>{
    console.log(data,"upcomh")
    return(dispatch)=>{
        axios.post(apiConfig.baseUrl+"e_lms/v1/student_page",data
        ).then((res)=>{
            dispatch(getupcomingSchedules(res.data));
        }).catch(err=>{
            console.log(err)
        })
}
}